import { useState } from 'react';
import { useAppForm } from 'shared/UI/UIKit/Form';
import { updateBellSchedule, type BellSchedule } from 'services/api';

interface UseBellScheduleEditProps {
  bellSchedule: BellSchedule;
  refreshTable: () => void;
}

export const useBellScheduleEdit = ({ bellSchedule, refreshTable }: UseBellScheduleEditProps) => {
  const [modalVisible, setModalVisible] = useState(false);

  const [form] = useAppForm<BellSchedule>();

  const showModal = () => {
    setModalVisible(true);
    form.setFieldsValue(bellSchedule);
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  const onSubmit = async () => {
    await form.validateFields().then(async (values) => {
      await updateBellSchedule(bellSchedule.id, { ...bellSchedule, ...values }).then(() => {
        hideModal();
        refreshTable();
      });
    });
  };

  return {
    state: {
      modalVisible,
      form,
    },
    methods: {
      showModal,
      hideModal,
      onSubmit,
    },
  };
};
